module.exports = __webpack_public_path__ + "img/img4.69ad444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img4.png
// module id = 299
// module chunks = 0